/*
	Spectral by HTML5 UP
	html5up.net | @ajlkn
	Free for personal and commercial use under the CCA 3.0 license (html5up.net/license)
*/

(function($) {

	var	$window = $(window),
		$body = $('body'),
		$wrapper = $('#page-wrapper'),
		$banner = $('#banner'),
		$header = $('#header');

	// Breakpoints.
		breakpoints({
			xlarge:   [ '1281px',  '1680px' ],
			large:    [ '981px',   '1280px' ],
			medium:   [ '737px',   '980px'  ],
			small:    [ '481px',   '736px'  ],
			xsmall:   [ null,      '480px'  ]
		});

	// Play initial animations on page load.
		window.addEventListener('load', function () {
  setTimeout(function () {
    document.body.classList.remove('is-preload');
  }, 100);
});


	// Mobile?
		if (browser.mobile)
			$body.addClass('is-mobile');
		else {

			breakpoints.on('>medium', function() {
				$body.removeClass('is-mobile');
			});

			breakpoints.on('<=medium', function() {
				$body.addClass('is-mobile');
			});

		}

	// Scrolly.
		$('.scrolly')
			.scrolly({
				speed: 1500,
				offset: $header.outerHeight()
			});

	// Menu.
		$('#menu')
			.append('<a href="#menu" class="close"></a>')
			.appendTo($body)
			.panel({
				delay: 500,
				hideOnClick: true,
				hideOnSwipe: true,
				resetScroll: true,
				resetForms: true,
				side: 'right',
				target: $body,
				visibleClass: 'is-menu-visible'
			});

	// Header.
		if ($banner.length > 0
		&&	$header.hasClass('alt')) {

			$window.on('resize', function() { $window.trigger('scroll'); });

			$banner.scrollex({
				bottom:		$header.outerHeight() + 1,
				terminate:	function() { $header.removeClass('alt'); },
				enter:		function() { $header.addClass('alt'); },
				leave:		function() { $header.removeClass('alt'); }
			});

		}
		if (/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
  document.body.classList.add('is-mobile');
}

		

})(jQuery);
document.addEventListener("DOMContentLoaded", function() {
  const track = document.querySelector(".carousel-track");
  const slides = Array.from(track.children);
  const nextButton = document.querySelector(".carousel-arrow.right");
  const prevButton = document.querySelector(".carousel-arrow.left");
  let currentIndex = 0;

  function updateCarousel() {
    track.style.transform = `translateX(-${currentIndex * 100}%)`;
  }

  nextButton.addEventListener("click", () => {
    currentIndex = (currentIndex + 1) % slides.length;
    updateCarousel();
  });

  prevButton.addEventListener("click", () => {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    updateCarousel();
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const btn = document.getElementById('klarna-buy-now');
  if (!btn) return;

  btn.addEventListener('click', function () {
    const variantId = btn.dataset.variantId;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    }).then(() => {
      window.location.href = '/checkout';
    });
  });
});

$(document).on("click", ".read-more-btn", function () {
  var $btn = $(this);
  var $text = $btn.find(".btn-text");
  var $moreText = $(".more-text");

  if ($moreText.is(":visible")) {
    $moreText.hide();
    $text.text("Show More");
    $btn.removeClass("is-open");
  } else {
    $moreText.show();
    $text.text("Show Less");
    $btn.addClass("is-open");
  }
});

$(document).on("click", ".faq-tab-title", function() {
  $(this).closest(".faq-tab").toggleClass("active");
});







document.querySelectorAll('.product-reviews-toggle .toggle-header').forEach(header => {
  header.addEventListener('click', () => {
    const toggle = header.parentElement;
    toggle.classList.toggle('active');
  });
});
